const meneDataConfig = ({
  menuData: [
    {
      id: '170282217698758656',
      parentId: '',
      name: 'SanDianYiSi',
      type: -1,
      title: '学生端',
      path: '',
      component: '',
      icon: 'ios-flower',
      url: '',
      buttonType: '',
      children: [
        {
          id: '168931998897803264f',
          parentId: '170282217698758656',
          name: 'home',
          type: 0,
          title: '首   页',
          path: '/',
          component: 'Main',
          icon: 'ios-home',
          url: '',
          buttonType: '',
          children: [
            {
              id: '168932347612237824',
              parentId: '168931998897803264f',
              name: 'tb-home',
              type: 0,
              title: '首   页',
              path: 'home',
              component: 'home/home',
              icon: 'ios-home',
              url: '',
              buttonType: '',
              children: null,
              permTypes: [
                'add',
                'edit',
                'delete'
              ]
            }
          ],
          permTypes: null
        },
        {
          id: '168919490489225216s',
          parentId: '170282217698758656',
          name: 'opusSquare',
          type: 0,
          title: '作品广场',
          path: '/student',
          component: 'Main',
          icon: 'ios-browsers',
          url: '',
          buttonType: '',
          children: [
            {
              id: '168920226136592384',
              parentId: '168919490489225216s',
              name: 'tb-opusSquare',
              type: 0,
              title: '作品广场',
              path: 'opusSquare',
              component: 'student/opusSquare',
              icon: 'ios-browsers',
              url: '',
              buttonType: '',
              children: null,
              permTypes: [
                'add',
                'edit',
                'delete'
              ]
            }
          ],
          permTypes: null
        },
        {
          id: '168919490489225216s1',
          parentId: '1702822176987586561',
          name: 'opusSquare',
          type: 0,
          title: '作品广场',
          path: '/student',
          component: 'Main',
          icon: 'ios-browsers',
          url: '',
          buttonType: '',
          children: [
            {
              id: '1689202261365923841',
              parentId: '168919490489225216s1',
              name: 'tb-opusSquare',
              type: 0,
              title: '作品广场',
              path: 'opusSquare',
              component: 'student/opusSquareSchool',
              icon: 'ios-browsers',
              url: '',
              buttonType: '',
              children: null,
              permTypes: [
                'add',
                'edit',
                'delete'
              ]
            }
          ],
          permTypes: null
        },
        {
          id: '171327131815524111a',
          parentId: '170282217613758656',
          name: 'createCenter',
          type: 0,
          title: '创作中心',
          path: '/student',
          component: 'Main',
          icon: 'ios-pie',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668113136',
              parentId: '171327131815524111a',
              name: 'tb-createCenter',
              type: 0,
              title: '创作中心',
              path: 'createCenter',
              component: 'student/createCenter',
              icon: 'ios-pie',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '171327131815514112a',
          parentId: '170282217698758656',
          name: 'myOpus',
          type: 0,
          title: '我的作品',
          path: '/student',
          component: 'Main',
          icon: 'ios-albums',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668443136',
              parentId: '171327131815514112a',
              name: 'tb-myOpus',
              type: 0,
              title: '我的作品',
              path: 'myOpus',
              component: 'student/myOpus',
              icon: 'ios-albums',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '171327131818814112a',
          parentId: '170282217698758656',
          name: 'myStudy',
          type: 0,
          title: '我的课程',
          path: '/student',
          component: 'Main',
          icon: 'ios-book',
          url: '',
          buttonType: '',
          children: [
            {
              id: '171327339668883136',
              parentId: '171327131818814112a',
              name: 'tb-myStudy',
              type: 0,
              title: '我的课程',
              path: 'myStudy',
              component: 'student/myStudy',
              icon: 'ios-book',
              url: null,
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '170295815057707008',
          parentId: '170282217698758656',
          name: 'myClassmate',
          type: 0,
          title: '我的同学',
          path: '/student',
          component: 'Main',
          icon: 'ios-people',
          url: '',
          buttonType: '',
          children: [
            {
              id: '170296968898154496',
              parentId: '170295815057707008',
              name: 'tb-myClassmate',
              type: 0,
              title: '我的同学',
              path: 'myClassmate',
              component: 'student/myClassmate',
              icon: 'ios-people',
              url: '',
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        {
          id: '170990039814115328',
          parentId: '170282217698758656',
          name: 'myCollection',
          type: 0,
          title: '我的收藏',
          path: '/student',
          component: 'Main',
          icon: 'ios-heart',
          url: '',
          buttonType: '',
          children: [
            {
              id: '170990502676533248',
              parentId: '170990039814115328',
              name: 'tb-myCollection',
              type: 0,
              title: '我的收藏',
              path: 'myCollection',
              component: 'student/myCollection',
              icon: 'ios-heart',
              url: '',
              buttonType: '',
              children: null,
              permTypes: []
            }
          ],
          permTypes: null
        },
        // {
        //   id: '170990039814110073',
        //   parentId: '170282217698758656',
        //   name: 'myCollection',
        //   type: 0,
        //   title: '我的题库',
        //   path: '/practise',
        //   component: 'practise',
        //   icon: 'ios-heart',
        //   url: '',
        //   buttonType: '',
        //   children: [
        //     {
        //       id: '170990502676533248',
        //       parentId: '170990039814110073',
        //       name: 'practise',
        //       type: 0,
        //       title: '我的题库',
        //       path: 'practise',
        //       component: 'practise',
        //       icon: 'ios-heart',
        //       url: '',
        //       buttonType: '',
        //       children: null,
        //       permTypes: []
        //     }
        //   ],
        //   permTypes: null
        // }
      ],
      permTypes: null
    }
  ]
})
export default meneDataConfig



// WEBPACK FOOTER //
// ./src/data/menuData.js